import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function CaseStudies() {
	return (
		<>
			<Helmet>
				<title>Our Projects | Apex Specialty Contracting LLC – Roofing Portfolio</title>
				<meta name="description" content="See recent roofing projects completed by Apex Specialty Contracting LLC in Tarpon Springs, Clearwater, Tampa, and across the Tampa Bay area." />
			</Helmet>
			<PageHeader title="Our Projects" subtitle="A selection of recent roofing replacements, storm restorations, and commercial projects across the Tampa Bay area." />
			<section className="section">
				<div className="container">
					<div className="grid" style={{ marginTop: 8 }}>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=800&auto=format&fit=crop" alt="Residential roof replacement in Tarpon Springs" />
							</div>
							<h3>Residential Roof Replacement — Tarpon Springs, FL</h3>
							<p className="helper">Complete tear-off and replacement of a 2,400 sq ft residential roof using GAF Timberline HDZ architectural shingles. The project was completed in 1.5 days. Customer received opt-in SMS updates at each milestone. Manufacturer's 30-year material warranty plus our 5-year workmanship warranty issued.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Residential</span>
								<span className="pill">Roof Replacement</span>
								<span className="pill">2,400 sq ft</span>
							</div>
						</div>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=800&auto=format&fit=crop" alt="Storm damage repair in Clearwater FL" />
							</div>
							<h3>Storm Damage Restoration — Clearwater, FL</h3>
							<p className="helper">A homeowner contacted us after Hurricane Idalia caused significant wind and water damage to their roof. We performed emergency tarping within hours of the call, completed a thorough damage assessment, worked directly with the insurance adjuster, and fully restored the roof within two weeks of the storm event.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Storm Restoration</span>
								<span className="pill">Insurance Claim</span>
								<span className="pill">Emergency Response</span>
							</div>
						</div>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1486325212027-8081e485255e?q=80&w=800&auto=format&fit=crop" alt="Commercial TPO roof installation in Tampa" />
							</div>
							<h3>Commercial TPO Roof Installation — Tampa, FL</h3>
							<p className="helper">Full TPO membrane roof system installation for a 12,000 sq ft warehouse facility in Tampa. Work was scheduled during off-hours to minimize business disruption. Project included new HVAC curb flashing, deck insulation, and a 20-year manufacturer NDL warranty. Completed on time and within budget.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Commercial</span>
								<span className="pill">TPO Roofing</span>
								<span className="pill">12,000 sq ft</span>
							</div>
						</div>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1503389152951-9f343605f61e?q=80&w=800&auto=format&fit=crop" alt="Metal roof installation in Palm Harbor FL" />
							</div>
							<h3>Standing Seam Metal Roof — Palm Harbor, FL</h3>
							<p className="helper">A homeowner seeking a long-lasting, low-maintenance solution chose a standing seam metal roof for their 1,800 sq ft home. We helped select a Galvalume steel panel system with a 50-year paint warranty. Installation included new underlayment, attic ventilation upgrades, and seamless gutter replacement.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Residential</span>
								<span className="pill">Metal Roofing</span>
								<span className="pill">Gutter Replacement</span>
							</div>
						</div>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1579427421635-a0015b804b2e?q=80&w=800&auto=format&fit=crop" alt="Tile roof restoration in Dunedin FL" />
							</div>
							<h3>Concrete Tile Re-Roof — Dunedin, FL</h3>
							<p className="helper">An aging tile roof with multiple broken tiles and failing underlayment was fully restored using Boral concrete tiles matching the original profile. The old underlayment was replaced with a 30-lb felt system and new flashing installed at all valleys and penetrations. The result: a roof built to last another 30+ years.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Residential</span>
								<span className="pill">Tile Roof</span>
								<span className="pill">Underlayment Replacement</span>
							</div>
						</div>
						<div className="card" style={{ padding: 22 }}>
							<div className="img-frame" style={{ marginBottom: 14 }}>
								<img src="https://images.unsplash.com/photo-1601459427108-47e20d579a35?q=80&w=800&auto=format&fit=crop" alt="Hail damage roof repair in New Port Richey FL" />
							</div>
							<h3>Hail Damage Claim &amp; Repair — New Port Richey, FL</h3>
							<p className="helper">After a severe hail storm, a homeowner needed help documenting damage and filing an insurance claim. Our team provided a detailed hail damage report with 60+ photographs, met the insurer's adjuster on-site, and successfully supplemented the initial claim for full replacement approval. Project completed in under 3 weeks from first call to final inspection.</p>
							<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
								<span className="pill">Hail Damage</span>
								<span className="pill">Insurance Claim</span>
								<span className="pill">Full Replacement</span>
							</div>
						</div>
					</div>

					<div className="card" style={{ padding: 24, marginTop: 32, textAlign: 'center' }}>
						<h3>Ready to start your project?</h3>
						<p className="helper">Contact us today for a free inspection and estimate. We serve the entire Tampa Bay area.</p>
						<div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginTop: 14 }}>
							<Link className="btn" to="/contact">Get a Free Estimate</Link>
							<a className="btn-outline" href="tel:9163160696">Call (916) 316-0696</a>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default CaseStudies;
